import { useState } from "react";
import CircleNumberCheckbox from "./CircleNumberCheckbox";
import usePersistantState from "src/hooks/usePersistantState";

export default function AbadRavanShenasiSingle({ option1, option2, number }) {
    const [options, setOptions] = usePersistantState(`ravan${number}`, {
        "1": false,
        "2": false,
        "3": false,
    })
    const handleOptions = (key) => {
        Object.keys(options).forEach(key => {
            if (options[key]) {
                options[key] = false;
            }
        });
        setOptions({
            ...options,
            [key]: !options[key],
        })
    }
    const optionsJSX = Object.keys(options).map((key) => (<CircleNumberCheckbox label={key} data={options} handleCheck={() => handleOptions(key)} />));

    return (
        <>
            <div className="flex justify-between my-3 text-sm text-[#777777]">
                <div className="w-[45%] text-right flex justify-end">
                    {option1}
                </div>
                <div className="w-[13%] flex justify-between cursor-pointer mx-2">
                    {optionsJSX}
                </div>
                <div className="w-[43%] text-left flex justify-start">
                    {option2}
                </div>
            </div>
        </>

    )
}